module.exports = __webpack_public_path__ + "img/step3-order2.ef39a138.png";